import { Calendar } from "lucide-react";
import { formatPostDate, toIsoDate } from "@/lib/postDate";

interface PostDateProps {
  /** ISO timestamp from the CMS (publish_at / created_at). */
  publishedAt?: string | null;
  /** Free-text fallback label ("July 2026") used when no timestamp exists. */
  label?: string | null;
  className?: string;
}

const PostDate = ({ publishedAt, label, className = "" }: PostDateProps) => {
  const display = formatPostDate(publishedAt, label);
  if (!display) return null;

  return (
    <time
      dateTime={toIsoDate(publishedAt)}
      className={`flex items-center gap-1.5 whitespace-nowrap ${className}`}
    >
      <Calendar className="h-3.5 w-3.5 shrink-0 opacity-70" aria-hidden="true" />
      {display}
    </time>
  );
};

export default PostDate;
